import {
  IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS,
  IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS,
  IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS,
  type IAiPlatformMountedApiServiceKey,
  type IAiPlatformPublicInfrastructureEndpointKey,
  type IAiPlatformPublicServiceKey,
} from "./generated/platform-public-endpoints";

export type IAiPlatformMountedApiEndpoint =
  (typeof IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS)[IAiPlatformMountedApiServiceKey];
export type IAiPlatformPublicServiceEndpoint =
  (typeof IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS)[IAiPlatformPublicServiceKey];
export type IAiPlatformPublicInfrastructureEndpoint =
  (typeof IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS)[IAiPlatformPublicInfrastructureEndpointKey];

export type IAiPlatformServiceKey =
  | IAiPlatformPublicServiceKey
  | IAiPlatformMountedApiServiceKey
  | IAiPlatformPublicInfrastructureEndpointKey;

export function readIAiMountedApiEndpoint(
  service: string,
): IAiPlatformMountedApiEndpoint | undefined {
  if (Object.prototype.hasOwnProperty.call(IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS, service)) {
    return IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS[service as IAiPlatformMountedApiServiceKey];
  }
  return undefined;
}

export function readIAiPublicServiceEndpoint(
  service: string,
): IAiPlatformPublicServiceEndpoint | undefined {
  if (Object.prototype.hasOwnProperty.call(IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS, service)) {
    return IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS[service as IAiPlatformPublicServiceKey];
  }
  return undefined;
}

export function readIAiPublicInfrastructureEndpoint(
  service: string,
): IAiPlatformPublicInfrastructureEndpoint | undefined {
  if (
    Object.prototype.hasOwnProperty.call(IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS, service)
  ) {
    return IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS[
      service as IAiPlatformPublicInfrastructureEndpointKey
    ];
  }
  return undefined;
}

export function readIAiPlatformEndpoint(service: string) {
  return (
    readIAiMountedApiEndpoint(service) ??
    readIAiPublicServiceEndpoint(service) ??
    readIAiPublicInfrastructureEndpoint(service)
  );
}

export function requireIAiKnownPlatformService(service: IAiPlatformServiceKey) {
  if (readIAiPlatformEndpoint(service)) {
    return;
  }
  throw new Error(
    `Unknown AIRange platform service "${String(service)}". Public endpoints must use a service-specific key registered in deploy/service-endpoints.json and generated in packages/shared/src/generated/platform-public-endpoints.ts.`,
  );
}
